import { useMemo } from "react";
import { YAxis } from "@mui/x-charts-premium";
import { TFunction } from "i18next";
import { BurnAssessmentColor } from "../BurnAssessmentColor";

export const useYAxis = (
  showIgnitionQualityCount: boolean,
  hideLabels: boolean,
  t: TFunction<"firefly-shared-ts-domain">
): Array<YAxis> => {
  return useMemo(() => {
    const yAxis: Array<YAxis> = [];

    yAxis.push({
      id: "burnCount",
      scaleType: "linear",
      label: !hideLabels ? t("Ignitions") : undefined,
      tickMinStep: 1,
      width: !hideLabels ? 60 : 30,
    } as YAxis);

    yAxis.push({
      id: "percentage",
      scaleType: "linear",
      label: !hideLabels ? t("Percentage") : undefined,
      width: !hideLabels ? 60 : 40,
      valueFormatter: (value) => `${value}%`,
      min: 0,
      max: 100,
      colorMap: !showIgnitionQualityCount
        ? {
            type: "continuous",
            min: 0,
            max: 100,
            color: [BurnAssessmentColor.Bad, BurnAssessmentColor.Good],
          }
        : undefined,
    } as YAxis);

    return yAxis;
  }, [showIgnitionQualityCount, hideLabels, t]);
};
